<template>
  <div style="background: #eee">
    <van-pull-refresh v-model="state.loading" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="car-container"
          v-for="list in state.list"
          :key="list"
          @click="toDetails(list.id)"
        >
          <div class="display_flex">
            <div class="block" :class="list.category">
              {{ state.categoryStatus[list.category] }}
            </div>
            <span class="font-bold t-f16-c1a m-l-5">{{ list.name }}</span>
          </div>
          <span class="t-f12-c66">{{ list.address }}</span>
          <div class="display_flex m-t-5" style="align-items: baseline">
            <span class="t-f12-cff8f00"
              >¥<span class="t-f22-cff8f00 m-l-5 font-bold">{{
                list.floor_price
              }}</span></span
            >
            <!-- <span class="text-delete t-f12-c99 m-l-5"
                  >¥{{ list.ceiling_price }}</span
                > -->
          </div>
          <div class="display_flex">
            <!-- <img src="" class="b-r-5 station-img" /> -->
            <div class="">
              <div class="display_flex">
                <div
                  v-if="list.sum_charging_pile_type.dc_count > 0"
                  class="m-r-15 c-n"
                >
                  <img src="../images/dc.png" class="t-i-u" />
                  <span class="t-f14-c1a font-bold m-l-5"
                    >{{ list.sum_charging_pile_type.dc
                    }}<span class="t-f14-c66"
                      >/{{ list.sum_charging_pile_type.dc_count }}</span
                    ></span
                  >
                </div>
                <div
                  v-if="list.sum_charging_pile_type.ac_count > 0"
                  class="c-n"
                >
                  <img src="../images/ac.png" class="t-i-u m-l-10" />
                  <span class="t-f14-c1a font-bold m-l-10"
                    >{{ list.sum_charging_pile_type.ac
                    }}<span class="t-f14-c66"
                      >/{{ list.sum_charging_pile_type.ac_count }}</span
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>

          <div
            class="navigation-v display_flex"
            @click.stop="openSdkLocation(list)"
          >
            <span class="t-f14-c1a font-bold"
              >{{ list.distance.toFixed(2) }}km</span
            >
            <img src="../images/navigation.png" class="navigation-icon m-l-5" />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { reactive, watch } from "vue";
import { useRouter } from "vue-router";
import request from "@/api/request";
import AMapLoader from "@amap/amap-jsapi-loader";
import wx from "weixin-js-sdk";
import { useStore } from "vuex";
import httpHelper from "@/helpers/http_helper";
let storeContext; //上下文
let pageCount = 1; //数据页数
let state = reactive({
  list: [],
  loading: false,
  finished: false,
  map: [],
  location: {},
  categoryStatus: {
    self_run: "自营",
    info: "第三方",
    third_party: "第三方",
  },
});
export default {
  props: {
    sort: String,
    stationType: String,
  },

  setup() {
    storeContext = useStore();
    const router = useRouter();
    function toDetails(id) {
      router.push(`/station/details/${id}`);
    }

    return {
      state,
      toDetails,
    };
  },
  // vue  destroy
  unmounted() {
    pageCount = 1;
  },
  mounted() {
    watch(this.$props, () => {
      //修改筛选条件后重置页面
      pageCount = 1;
      this.apiStationList();
    });
  },

  methods: {
    //初始化数据
    async onLoad() {
      // //注入微信配置
      this.setWechatConfig();
      // //获取定位
      state.location = this.loadUserCoordinate();
      if (state.location.latitude == undefined) {
        this.initAmap();
      } else {
        this.apiStationList();
      }
    },
    initAmap() {
      let that = this;
      AMapLoader.load({
        key: process.env.VUE_APP_AMAP_KEY || "224c5376ecce94075638d694f7fcba34",
        version: "1.4.15",
        plugins: ["AMap.Geolocation"],
        Loca: {
          version: "1.3.2",
        },
      })
        .then((AMap) => {
          AMap.plugin("AMap.Geolocation", function () {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000,
            });

            geolocation.getCurrentPosition(function (status, result) {
              if (status == "complete") {
                onComplete(result);
              } else {
                onError(result);
              }
            });

            function onComplete(data) {
              // data是具体的定位信息
              state.location.latitude = data.position.lat;
              state.location.longitude = data.position.lng;
              that.apiStationList();
            }

            function onError(data) {
              // 定位出错
              console.log(data);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    apiStationList() {
      httpHelper.showLoading();
      let props = this.$props;
      let filterData = {};
      filterData["sort"] = props.sort;
      filterData["page"] = pageCount;
      filterData["longitude"] = state.location.longitude;
      filterData["latitude"] = state.location.latitude;
      //如果选择了站类型 就赋值
      if (props.stationType != "") {
        filterData["station_type"] = props.stationType;
      }
      request
        .getIndexStationList(filterData)
        .then((res) => {
          state.loading = false;
          httpHelper.hideLoading();
          if (res.data.results.length == 0) {
            state.finished = true;
            return;
          }
          if (pageCount == 1) {
            state.list.length = 0;
            state.finished = false;
          }
          state.list = state.list.concat(res.data.results);
          pageCount++;
        })
        .catch(() => {
          state.loading = false;
          httpHelper.hideLoading();
        });
    },
    //获取用户坐标
    async loadUserCoordinate() {
      //配置微信sdk参数

      let wechatLocation = await this.getUserPosition();
      return wechatLocation;
    },
    //读取缓存用户信息
    readStorePosition() {
      let userPosition = storeContext.state.UserPosition;
      if (userPosition !== "") {
        return userPosition;
      }
      return null;
    },
    //下拉刷新
    onRefresh() {
      //重置页数
      pageCount = 1;
      this.apiStationList();
    },
    //获取用户信息
    async getUserPosition() {
      return new Promise((resolve, reject) => {
        wx.getLocation({
          type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: (res) => {
            let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
            let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
            //store 缓存latitude
            storeContext.commit("setPosition", {
              lat: latitude,
              lng: longitude,
            });
            resolve({ latitude, longitude });
          },
          fail: () => {
            reject("定位失败!");
          },
        });
      });
    },
    //打开微信地图
    openSdkLocation(item) {
      wx.openLocation({
        latitude: item.latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: item.longitude, // 经度，浮点数，范围为180 ~ -180
        name: item.name, // 位置名。
        address: item.address,
      });
    },
    //配置微信sdk信息
    async setWechatConfig() {
      let resp = await request.getWxConfigInfo({
        escaped_url: encodeURIComponent(window.location.href),
      });

      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: resp.data.appId, // 必填，公众号的唯一标识
        timestamp: resp.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: resp.data.nonceStr, // 必填，生成签名的随机串
        signature: resp.data.signature, // 必填，签名
        jsApiList: ["checkJsApi", "getLocation", "openLocation"], // 必填，需要使用的JS接口列表
      });
      return new Promise((resolve, reject) => {
        wx.ready(() => {
          // config信息验证后会执行ready方法
          resolve();
        });
        // 验证失败
        wx.error(() => {
          // this.initAmap();
          reject();
        });
      });
    },
  },
};
</script>

<style scoped>
.c-n {
  align-items: center;
}
.t-i-u {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
.car-container {
  border-radius: 5px;
  background: #fff;
  padding: 15px;
  position: relative;
  margin: 0px 10px 10px 10px;
}
.station-img {
  width: 55px;
  height: 55px;
}

.charge-type-block {
  border: 1px solid #ebebeb;
  color: #666;
  line-height: 15px;
  height: 15px;
}
.navigation-v {
  border-radius: 13px;
  background-image: url("../images/map_back.png");
  padding: 5px 15px;
  position: absolute;
  right: 18px;
  bottom: 18px;
}
.navigation-icon {
  width: 20px;
  height: 20px;
}
</style>
